import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material';

@Component({
  selector: 'cc-lg-popup-theme-color',
  templateUrl: './popup-theme-color.component.html',
  styleUrls: ['./popup-theme-color.component.scss']
})
export class PopupThemeColorComponent implements OnInit {
  @Input() popupSettings: FormGroup;

  constructor() {}

  ngOnInit() {}

  reverse(event: MatCheckboxChange) {
    this.popupSettings.controls.reverseTheme.setValue(event.checked);
  }
}
